import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Lopettia-flavored Input. Dark card surface, faint default border,
 * soft 3px teal-glow on focus (no hard ring). Verbatim from lorenza.css
 * §inputs / textareas.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-[6px] border border-[var(--color-lop-border)] bg-[var(--color-lop-bg-card)] px-3 py-2 text-sm text-[var(--color-lop-text-primary)] transition-colors',
          'placeholder:text-[var(--color-lop-text-dim)]',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'focus-visible:outline-none focus-visible:border-[var(--color-lop-teal)] focus-visible:bg-[var(--color-lop-bg-card-hi)] focus-visible:shadow-[0_0_0_3px_var(--color-lop-teal-glow)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
